import { useEffect, useState } from 'react';
import { getTaxData } from '../services/tax-identifiers/api';
import { useTaxIdConfig } from '../pages/settings/payment-and-subscription/hooks/use-tax-id-config';

export const useTaxIdBanner = () => {
  const { isTaxIdAvailable } = useTaxIdConfig();
  const [showTaxIdBanner, setShowTaxIdBanner] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { taxIdentifier } = await getTaxData();
        setShowTaxIdBanner(!taxIdentifier && isTaxIdAvailable);
      } catch {
        setShowTaxIdBanner(false);
      }
    };
    fetchData();
  }, [isTaxIdAvailable]);

  return showTaxIdBanner;
};
